import { render, staticRenderFns } from "./IngestorAdd.vue?vue&type=template&id=c7b969d2"
import script from "./IngestorAdd.vue?vue&type=script&lang=js"
export * from "./IngestorAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports